export default (params) => ({
  trigger: {
    name: 'mini_product_page.add_accessory_to_cart',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      attached_item_id: {
        type: 'integer',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'options_row',
          'recommended_accessories',
          'product_type_section',
          'employee_atc_page',
          'employee_ato_page',
          'configurator',
        ],
      },
    },
    event: {
      name: 'add_accessory_to_cart',
      params: {
        card_has_highlighted_segment: null,
      },
    },
    nonInt: true,
  },
});
